// src/tiles/InsightTile.jsx
import React from 'react';
import TileShell from './TileShell';
import PrimaryScorePill from './PrimaryScorePill';
import ScoreBadge from './ScoreBadge';
import InterviewsBadge from './InterviewsBadge';
import ReceiptsList from './ReceiptsList';
import VariantPill from './VariantPill';
import { scoreHelp } from '../../utils/scoreHelp';

export default function InsightTile({ title, count, variant, score, receipts, avgSentiment, sectionTotal }) {
  const isPos = variant === 'positive';
  const help = isPos ? scoreHelp.insightPos : scoreHelp.insightNeg;
  const label = help.label; // 'Positivity Score' | 'Negativity Score'
  const tone = isPos ? 'green' : 'red';
  const info = `${help.calc}\n${help.meaning}`;

  const primaryScore = (
    <PrimaryScorePill
      label={label}
      value={score}
      infoTooltip={info}
      tone={tone}
    />
  );

  const pct = sectionTotal ? Math.round((count / sectionTotal) * 100) : 0;
  const metricsRow = (
    <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
      <InterviewsBadge percent={pct} count={count} />
      {/* Rename + visualize intensity (0..10) */}
      <ScoreBadge label="Intensity" value={avgSentiment} metricKey="intensity" />
    </div>
  );

  return (
    <TileShell
      typePill="insight"
      variantPill={<VariantPill variant={variant} />}
      title={title}
      primaryScore={primaryScore}
      metricsRow={metricsRow}
      receipts={<ReceiptsList receipts={receipts || []} />}
    />
  );
}
